import { TruckIcon as TheIcon } from "@heroicons/react/24/outline";
import { cn } from "helpers/classNames";

type Props = {
  className?: string;
};

export const TruckIcon = ({ className }: Props) => (
  <TheIcon className={cn("h-4 w-4 text-gray-400", className)} />
);
